module.exports = __webpack_public_path__ + "assets/images/BagCount.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/BagCount.png
// module id = 387
// module chunks = 1